import { cn } from '@/lib/utils';

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4';
type HeadingSize = 'xl' | 'lg' | 'md' | 'sm';

type DisplayHeadingProps = {
  children: React.ReactNode;
  as?: HeadingTag;
  size?: HeadingSize;
  /** Reserved for WP12 motion enhancement; static hierarchy is the baseline. */
  animate?: boolean;
  className?: string;
};

const sizeClasses: Record<HeadingSize, string> = {
  xl: 'text-display-xl',
  lg: 'text-display-lg',
  md: 'text-display-md',
  sm: 'text-display-sm',
};

/** Hierarchy: primary section titles with fluid scale; no motion dependency. */
export const DisplayHeading = ({
  children,
  as: Tag = 'h2',
  size = 'lg',
  className,
}: DisplayHeadingProps) => {
  return (
    <Tag
      className={cn(
        'font-display text-ink text-balance font-bold leading-tight',
        sizeClasses[size],
        className
      )}
    >
      {children}
    </Tag>
  );
};
